import { Outlet } from 'react-router-dom';
import Footer from '../Footer';
import Header from '../Header';
import TopBar from '../TopBar';
import styles from './RootLayout.module.css';

export default function RootLayout() {
  return (
    <div className={styles.page}>
      <a className={styles.skipLink} href="#main-content">
        Saltar al contenido principal
      </a>
      <TopBar />
      <Header />
      <main id="main-content" className={styles.main} tabIndex={-1}>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
